<template>
  <div
    class="cpt-chat-room-avatar flex-center overflow-hidden relative"
    :class="{
      '!bg-bd-fl': keep_active && !img
    }"
    :style="{
      width: width + 'px',
      height: width + 'px',
      'border-radius': radius + 'px'
    }">
    <template v-if="img">
      <ChatImg 
        class="default-img" 
        :src="img" 
        :lazy="lazy" 
        :animation="animation"
        :webp_quality="webp_quality"
        :thumbnail="`${width * (img.includes('.gif') ? 5 : 3)}x`"
        @load="$emit('load', $event)"
        v-bind="inject_chat_img_props"
      />
    </template>
    <template v-else>
      <span
        v-if="room_name"
        v-emoji-html="{text: getRoomIconStr(room_name, only_one_char), style: { width: icon_width + 'px', height: icon_width + 'px' }}"
        class="text-[12px] text-tx-3 font-bold"
        :style="{
          fontSize: icon_width + 'px',
          color: keep_active ? '#fff' : ''
        }"  
      ></span>
      <i
        class="icon-room iconfont text-tx-4 m-0"
        v-else
        :style="{
          width: icon_width + 'px',
          height: icon_width + 'px',
          fontSize: icon_width + 'px',
          color: keep_active ? '#fff' : ''
        }"></i>
    </template>
  </div>
</template>

<script>
import { getRoomIconStr } from '_lib/utils/utilsRoom'

export default {
  name: 'ChatRoomAvatar',
  props: {
    webp_quality: {
      type: Number,
      default: 0
    },
    img: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 32
    },
    icon_width: {
      type: Number,
      default: 12
    },
    keep_active: {
      type: Boolean,
      default: false
    },
    room_name: {
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: true
    },
    animation: {
      type: Boolean,
      default: true
    },
    radius: {
      type: Number,
      default: 8
    },
    chat_img_props: {
      type: Object || null,
      default: null
    },
    only_one_char: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      getRoomIconStr: getRoomIconStr,
    }
  },
  computed: {
    inject_chat_img_props() {
      const default_chat_img_props = {
        gif_active_type: "hover",
        hover_dom_handler: () => this.$el
      }
      if (this.chat_img_props) {
        return {
          ...default_chat_img_props,
          ...this.chat_img_props
        }
      }
      return default_chat_img_props
    }
  }
};
</script>
